import * as React from "react";

class ButtonEText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="buttonE-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 244.741 88.204"
      >
        <path
          fill="#fcfaee"
          d="M97.12,50.37v2.16H83.23V50.37h5.86v-1H84.52V47.27h4.57V46.21H84.68v-2l-1.52,2.07a18.3,18.3,0,0,0-1.38-2.32v9H79.14V44.65a20.07,20.07,0,0,1-2.5,4.55,13.87,13.87,0,0,0-1.26-2.6,22.5,22.5,0,0,0,3.4-6.15H75.86V37.9h3.28V35.24c-1,.18-1.9.34-2.8.45a9.68,9.68,0,0,0-.76-2.09,32.52,32.52,0,0,0,7.12-1.9l1.82,2.09a23.92,23.92,0,0,1-2.74.87V37.9h2.46v2.55H81.78v.66c.6.51,2.39,2.37,2.9,3V38.52h4.41v-.94H83.92V35.46h5.17v-1c-1.5.07-3,.12-4.34.14a7.52,7.52,0,0,0-.6-2A77.3,77.3,0,0,0,95,31.65L96.6,33.7a47.29,47.29,0,0,1-4.9.62v1.14h4.94v2.12H91.7v.94h4.57v7.69H91.7v1.06h4.57v2.06H91.7v1ZM87,41.55h2V40.42H87Zm2,2.78V43.16H87v1.17Zm2.61-3.91v1.13h2.12V40.42Zm2.12,2.74H91.7v1.17h2.12Z"
        />
        <path
          fill="#fcfaee"
          d="M105,45c-.23-.6-.64-1.47-1.06-2.34V52.89h-2.57V44.65a19.12,19.12,0,0,1-1.88,4.13A16,16,0,0,0,98.22,46a22.48,22.48,0,0,0,3.17-7.76H98.73V35.74h2.66V31.47H104v4.27h1.93v2.53H104v.82c.69.92,2.32,3.4,2.69,4ZM120,50.19v2.29H105.23V50.19h2V37.44h3.35c.09-.44.16-.9.25-1.4h-4.45V33.79h4.75c.09-.83.16-1.63.21-2.34l2.78.06c-.12.76-.25,1.5-.41,2.28h5.64V36h-6.1c-.12.5-.26,1-.35,1.4h5.31V50.19ZM109.68,39.44V40.7h5.86V39.44Zm5.86,3.14h-5.86v1.27h5.86Zm-5.86,3.1V47h5.86V45.68Zm0,4.51h5.86V48.85h-5.86Z"
        />
        <path
          fill="#fcfaee"
          d="M127.61,40.82c0,.41,0,.87,0,1.31,2.41-.76,2.71-1.73,2.71-2.85v-2h8.77v2.89c0,.57.05.8.39.8h1.27a4.11,4.11,0,0,0,1.31-.18c0,.73.13,1.77.2,2.43a4.49,4.49,0,0,1-1.44.19h-1.52c-2.37,0-2.87-.92-2.87-3.26v-.55H132.8a4.51,4.51,0,0,1-2.94,4.36h9l.46-.09,1.63.69a11,11,0,0,1-3.79,5.14,25.17,25.17,0,0,0,5.39.85,10.94,10.94,0,0,0-1.49,2.39,21.65,21.65,0,0,1-6.66-1.63,26.63,26.63,0,0,1-6.2,1.67,8.79,8.79,0,0,0-1.15-2.29,25,25,0,0,0,4.83-1,11.3,11.3,0,0,1-2.67-3.3l.69-.19h-1.22V43.94h.21a9.89,9.89,0,0,0-1.31-1.61c-.14,3.51-.78,7.88-3.19,10.68a11.73,11.73,0,0,0-2.28-1.59,11.56,11.56,0,0,0,2.53-6.1c-.85.55-1.68,1.08-2.5,1.56l-.78-2.53c.92-.41,2.2-1.08,3.56-1.79,0-.62,0-1.22,0-1.79V40l-1.65.76a31.34,31.34,0,0,0-1.91-4.14l2.16-.94c.44.78,1,1.7,1.4,2.57V33.81h7.92c-.23-.62-.53-1.28-.78-1.84l2.74-.66c.38.78.82,1.74,1.1,2.5h7v2.5H127.61Zm4.21,5.39a7.44,7.44,0,0,0,2.66,2.39,9.33,9.33,0,0,0,2.82-2.39Z"
        />
        <path
          fill="#fcfaee"
          d="M149.82,36h-4.76V33.49h4.76v-2h2.68v2H155V36H152.5V38.2h-2.68ZM147,38.91h16.55V53h-2.75V52H149.63v1H147Zm2.61,2.48v2.78h4.18V41.39Zm4.18,8.11V46.6h-4.18v2.9Zm11.62-16V36h-4.87v2.2h-2.73V36h-2.2V33.49h2.2v-2h2.73v2Zm-4.61,7.9h-4.34v2.78h4.34Zm0,8.11V46.6h-4.34v2.9Z"
        />
      </svg>
    );
  }
}

export default ButtonEText;



// WEBPACK FOOTER //
// ./src/storyC/components/ButtonEText.tsx